export const getUser = ({ account }) => account.user;
